import React from 'react';
import { makeStyles } from '@mui/styles';
import Chip from '@mui/material/Chip';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    padding: 4,
    color: '#555'
  },
  chip: {
    margin: 4,
    backgroundColor: '#f0f0f0',
    color: '#555'
  },
}));

export default function ChipsArray(props) {
  const classes = useStyles();
  const chipData = props.chipData ? props.chipData : []
  return (
    <div className={classes.root}>
      {chipData.map((data, key) => {
        return (
          <Chip
            key={key}
            label={data}
            size="small"
            className={classes.chip}
          />
        );
      })}
    </div>
  );
}
